// Generated by purs version 0.15.16
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_VDom_Types from "../Halogen.VDom.Types/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Halogen_HTML_Core.bifunctorHTML);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Eq.eqString);
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Halogen_VDom_Types.eqNamespace));
var eq3 = /* #__PURE__ */ Data_Eq.eq(Halogen_VDom_Types.eqElemName);
var unfoldHTML = function (c) {
    var u = function (x) {
        return Halogen_HTML_Core.renderWidget(identity)(Data_Either.either(u)(Halogen_HTML_Core.widget))(c(x));
    };
    return u;
};
var unfoldPlainHTML = function (c) {
    return unfoldHTML((function () {
        var $60 = lmap(Data_Either.Left.create);
        return function ($61) {
            return $60(c($61));
        };
    })());
};
var overlay = function (panel_classes) {
    return function (contents) {
        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("overlay") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.classes(panel_classes) ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("overlay_content") ])(contents) ]) ]);
    };
};
var eqTuple = function (eqX) {
    return function (eqY) {
        return function (v) {
            return function (v1) {
                return eqX(v.value0)(v1.value0) && eqY(v.value1)(v1.value1);
            };
        };
    };
};
var eqArray = function (eqElem) {
    return function (l) {
        return function (r) {
            var eqIndexed = function (v) {
                return function (v1) {
                    if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Just) {
                        return eqElem(v.value0)(v1.value0);
                    };
                    return false;
                };
            };
            var loop = function (ll) {
                var lloop = function (i) {
                    var $31 = ll <= i;
                    if ($31) {
                        return true;
                    };
                    return eqIndexed(Data_Array.index(l)(i))(Data_Array.index(r)(i)) && lloop(1 + i | 0);
                };
                return lloop;
            };
            return Data_Array.length(l) === Data_Array.length(r) && loop(Data_Array.length(l))(0);
        };
    };
};
var eqVDom = function (eqAttr) {
    return function (eqWidget) {
        var eqNoGraft = function (v) {
            return function (v1) {
                if (v instanceof Halogen_VDom_Types.Text && v1 instanceof Halogen_VDom_Types.Text) {
                    return v.value0 === v1.value0;
                };
                if (v instanceof Halogen_VDom_Types.Elem && v1 instanceof Halogen_VDom_Types.Elem) {
                    return eq2(v.value0)(v1.value0) && (eq3(v.value1)(v1.value1) && (eqAttr(v.value2)(v1.value2) && eqArray(deGraft)(v.value3)(v1.value3)));
                };
                if (v instanceof Halogen_VDom_Types.Keyed && v1 instanceof Halogen_VDom_Types.Keyed) {
                    return eq2(v.value0)(v1.value0) && (eq3(v.value1)(v1.value1) && (eqAttr(v.value2)(v1.value2) && eqArray(eqTuple(eq1)(deGraft))(v.value3)(v1.value3)));
                };
                if (v instanceof Halogen_VDom_Types.Widget && v1 instanceof Halogen_VDom_Types.Widget) {
                    return eqWidget(v.value0)(v1.value0);
                };
                return false;
            };
        };
        var deGraft = function ($copy_v) {
            return function ($copy_v1) {
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1) {
                    if (v instanceof Halogen_VDom_Types.Grafted && v1 instanceof Halogen_VDom_Types.Grafted) {
                        $tco_var_v = Halogen_VDom_Types.runGraft(v.value0);
                        $copy_v1 = Halogen_VDom_Types.runGraft(v1.value0);
                        return;
                    };
                    if (v instanceof Halogen_VDom_Types.Grafted) {
                        $tco_var_v = Halogen_VDom_Types.runGraft(v.value0);
                        $copy_v1 = v1;
                        return;
                    };
                    if (v1 instanceof Halogen_VDom_Types.Grafted) {
                        $tco_var_v = v;
                        $copy_v1 = Halogen_VDom_Types.runGraft(v1.value0);
                        return;
                    };
                    $tco_done = true;
                    return eqNoGraft(v)(v1);
                };
                while (!$tco_done) {
                    $tco_result = $tco_loop($tco_var_v, $copy_v1);
                };
                return $tco_result;
            };
        };
        return deGraft;
    };
};
export {
    overlay,
    eqVDom,
    unfoldPlainHTML,
    unfoldHTML
};
//# sourceMappingURL=index.js.map
